import { render, staticRenderFns } from "./EntityDictsDetail.vue?vue&type=template&id=d1e9399c&scoped=true"
import script from "./EntityDictsDetail.vue?vue&type=script&lang=js"
export * from "./EntityDictsDetail.vue?vue&type=script&lang=js"
import style0 from "./EntityDictsDetail.vue?vue&type=style&index=0&id=d1e9399c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e9399c",
  null
  
)

export default component.exports